module.exports = __webpack_public_path__ + "img/album1-image-1.56e5804c.jpg";